"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeTierWidget = void 0;
var journey_services_1 = require("@athena-portal/journey-services");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var commonFunctions_1 = require("../../../commonFunctions");
var FalconAccordion_1 = require("../../../components/FalconAccordion");
var services_1 = require("@falcon/services");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var modals = require("./tierTable/TierTableInfoModalRenderers");
var react_router_dom_1 = require("react-router-dom");
var SuggestionModal_1 = require("../../../components/modals/SuggestionModal");
var journey_model_1 = require("@athena-portal/journey-model");
var AnnualHomeTierWidget = exports.AnnualHomeTierWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeTierWidget, _super);
    function AnnualHomeTierWidget(props) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        _this = _super.call(this, props) || this;
        if (((_a = _this.props.interaction.uistate) === null || _a === void 0 ? void 0 : _a.annualHomeAddonsState) === null) {
            _this.recordPreviousAddons();
        }
        _this.state = {
            buildingsAdPopupTriggered: !!((_b = _this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.buildingAccidentalDamage),
            contentsAdPopupTriggered: !!((_c = _this.props.interaction.annualHomeFixedAddons) === null || _c === void 0 ? void 0 : _c.contentsAccidentalDamage),
            legalExpensesPopupTriggered: !!((_d = _this.props.interaction.annualHomeFixedAddons) === null || _d === void 0 ? void 0 : _d.homeLegalExpenses),
            homeEmergencyPopupTriggered: !!((_e = _this.props.interaction.annualHomeFixedAddons) === null || _e === void 0 ? void 0 : _e.homeEmergency),
            isSuggestionModalOpen: false
        };
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleAddonChangeEvent = _this.handleAddonChangeEvent.bind(_this);
        _this.switchPremiumType = _this.switchPremiumType.bind(_this);
        _this.handleTierPopup = _this.handleTierPopup.bind(_this);
        _this.toggleSuggestionModal = _this.toggleSuggestionModal.bind(_this);
        _this.navigateToRenewal = _this.navigateToRenewal.bind(_this);
        return _this;
    }
    AnnualHomeTierWidget.prototype.prepareTierTableParams = function () {
        if (this.props.interaction.eligibleTier === services_1.GOLD_TIER) {
            this.renderBronzeTier = false;
        }
        else if (this.props.interaction.eligibleTier === services_1.SILVER_TIER) {
            this.renderBronzeTier = false;
        }
        else {
            this.renderBronzeTier = true;
        }
    };
    AnnualHomeTierWidget.prototype.render = function () {
        {
            this.prepareTierTableParams();
        }
        if (this.props.interaction.eligibleTier === services_1.GOLD_TIER) {
            return (React.createElement("div", { className: "annual-home-tier-widget" },
                React.createElement("h2", { className: "text-blue-2 quote-section-title" }, "What's covered"),
                this.renderPremierCoverList(),
                this.renderPolicyDocumentSection()));
        }
        else {
            return (React.createElement("div", { className: "annual-home-tier-widget" },
                React.createElement("h2", { className: "text-blue-2 quote-section-title" }, "Choose the cover that's right for you"),
                this.getSetting("showPremiumTypeSwitch", true) && this.notAnnualOnly() && this.renderPremiumTypeSwitch(),
                this.renderCoverTable(),
                this.renderPolicyDocumentSection()));
        }
    };
    AnnualHomeTierWidget.prototype.renderPremiumTypeSwitch = function () {
        var _this = this;
        var annualSelected = this.props.interaction.factors.premiumType === "annual";
        return (React.createElement("div", { className: "row premium-type-switch" },
            React.createElement("div", { className: "col-12" },
                React.createElement("div", { className: "float-right tier-premium-type" },
                    React.createElement("div", { className: annualSelected ? "annual selected" : "annual", onClick: function (e) { return _this.switchPremiumType(); } },
                        React.createElement("span", null, "Annual")),
                    React.createElement("div", { className: "p-0 background-color-grey" },
                        React.createElement("div", { className: annualSelected ? "tier-premium-type-input annual" : "tier-premium-type-input monthly", onClick: function (e) { return _this.switchPremiumType(); } },
                            React.createElement("span", null))),
                    React.createElement("div", { className: annualSelected ? "monthly" : "monthly selected", onClick: function (e) { return _this.switchPremiumType(); } },
                        React.createElement("span", null, "Monthly"))))));
    };
    AnnualHomeTierWidget.prototype.notAnnualOnly = function () {
        return this.props.interaction.radarPolicyData.instalmentAllowedStatus !== 'N' && this.props.interaction.radarPolicyData.instalmentAllowedStatus !== 'D';
    };
    AnnualHomeTierWidget.prototype.renderCoverTable = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var tier = this.props.interaction.coverTier;
        var bronzeHidden = this.props.interaction.eligibleTier === services_1.SILVER_TIER ? " clickthrough" : "";
        var goldTier = this.props.interaction.coverTier === services_1.GOLD_TIER;
        return (React.createElement("div", { className: "tier-table " + tier.toLowerCase() + bronzeHidden },
            this.renderTierCheckboxes(),
            React.createElement("div", { className: "row header-row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("h5", null, "Buildings & Contents"))),
            this.renderIncludedCoverRow("Fire, lightning, escape of water or oil"),
            this.renderIncludedCoverRow("Theft, storm, flood, impact, vandalism"),
            this.renderCoverLimit("Buildings Cover", 500000, 1000000, 1000000, modals.renderBuildingCoverModal()),
            this.renderCoverLimit("Contents Cover", 50000, 100000, 150000, modals.renderContentsCoverModal()),
            this.renderOptionalExtras("Buildings Accidental Damage", "annualHomeFixedAddons.buildingAccidentalDamage", goldTier ? (_a = this.props.interaction.uistate) === null || _a === void 0 ? void 0 : _a.annualHomeAddonsState.buildingAccidentalDamage : (_b = this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.buildingAccidentalDamage, "uistate.annualHomeAddonsState.buildingAccidentalDamage", modals.renderBuildingsAccidentalDamageModal()),
            this.renderOptionalExtras("Contents Accidental Damage", "annualHomeFixedAddons.contentsAccidentalDamage", goldTier ? (_c = this.props.interaction.uistate) === null || _c === void 0 ? void 0 : _c.annualHomeAddonsState.contentsAccidentalDamage : (_d = this.props.interaction.annualHomeFixedAddons) === null || _d === void 0 ? void 0 : _d.contentsAccidentalDamage, "uistate.annualHomeAddonsState.contentsAccidentalDamage", modals.renderContentsAccidentalDamageModal()),
            this.renderOptionalExtras("Home Legal Expenses", "annualHomeFixedAddons.homeLegalExpenses", goldTier ? (_e = this.props.interaction.uistate) === null || _e === void 0 ? void 0 : _e.annualHomeAddonsState.homeLegalExpenses : (_f = this.props.interaction.annualHomeFixedAddons) === null || _f === void 0 ? void 0 : _f.homeLegalExpenses, "uistate.annualHomeAddonsState.homeLegalExpenses", modals.renderLegalExpensesModal()),
            this.renderOptionalExtras("Home Emergency", "annualHomeFixedAddons.homeEmergency", goldTier ? (_g = this.props.interaction.uistate) === null || _g === void 0 ? void 0 : _g.annualHomeAddonsState.homeEmergency : (_h = this.props.interaction.annualHomeFixedAddons) === null || _h === void 0 ? void 0 : _h.homeEmergency, "uistate.annualHomeAddonsState.homeEmergency", modals.renderHomeEmergencyModal()),
            React.createElement(FalconAccordion_1.FalconAccordion, { togglePositionTop: false, toggleHidden: React.createElement("div", { className: "toggle" },
                    React.createElement("i", { className: "fas fa-plus glyph-margin" }),
                    " Show more"), toggleShown: React.createElement("div", { className: "toggle accordion-expanded" },
                    React.createElement("i", { className: "fas fa-minus glyph-margin" }),
                    " Show less ") }, this.renderAdditionalCoverDetails()),
            this.renderSelectButtons(tier, bronzeHidden),
            this.renderSuggestionModal()));
    };
    AnnualHomeTierWidget.prototype.renderAdditionalCoverDetails = function () {
        return (React.createElement(React.Fragment, null,
            this.renderIncludedCoverRow("Accidental damage to cables, underground pipes and drains", modals.renderCablePipeAccidentalDamageModal()),
            this.renderCoverLimit("Alternative Accommodation", 40000, 90000, 125000, modals.renderAlternativeAccommodationModal()),
            this.renderCoverLimit("Money in the home", 250, 500, 1000, modals.renderMoneyModal()),
            this.renderCoverLimit("Credit cards", 1000, 1000, 1000, modals.renderCreditCardsModal()),
            this.renderCoverLimit("Loss of keys", 500, 750, 1000, modals.renderLossOfKeysModal()),
            this.renderCoverLimit("Fatal injury", undefined, undefined, 5000, modals.renderFatalInjuryModal()),
            this.renderCoverLimit("Title deeds", undefined, 1000, 2500, modals.renderTitleDeedsModal()),
            this.renderCoverLimit("Liability", 1000000, 2000000, 2000000, modals.renderLiabilityModal()),
            this.renderCoverLimit("Business equipment", 1000, 5000, 10000, modals.renderBusinessEquipmentModal()),
            this.renderOptionalCovers("Accidental damage to entertainment items", false, false, true, modals.renderEntertainmentItemModal()),
            this.renderOptionalCovers("Accidental damage to glass & baths & basins", false, true, true, modals.renderGlassAndSanitaryModal()),
            this.renderCoverLimit("Contents away from the home", undefined, 5000, 10000, modals.renderContentsAwayModal()),
            this.renderCoverLimit("Contents in outbuildings", 1000, 3000, 5000, modals.renderContentsInOutbuildingsModal()),
            this.renderMatchingSets(),
            this.renderCoverLimit("Contents in the garden", undefined, 750, 1000, modals.renderGardenContentsModal()),
            this.renderCoverLimit("Freezer contents", 250, 500, 1000, modals.renderFreezerContentsModal()),
            this.renderCoverLimit("Downloaded information", 1000, 2500, undefined, modals.renderDonwloadedInformationModal()),
            this.renderCoverLimit("Student contents away from the home", undefined, 5000, 10000, modals.renderStudentContentsModal()),
            this.renderCoverLimit("Visitor belongings", undefined, 1000, 2500, modals.renderVisitorEffectsModal()),
            this.renderCoverLimit("Contents in a nursing home", undefined, 5000, 10000, modals.renderNursingHomeModal()),
            this.renderCoverLimit("Plants in the garden", undefined, 1000, 2500, modals.renderPlantsModal()),
            this.renderIncludedCoverRow("Bicycles in the home", modals.renderBicyclesModal()),
            this.renderProfessionalRemoval(),
            this.renderCoverLimit("Valuables in the home", 10000, 20000, 30000, modals.renderValuablesModal()),
            this.renderCoverLimit("Valuable single article limit", 2000, 2000, 2000, modals.renderValuableSingleArticleModal())));
    };
    AnnualHomeTierWidget.prototype.renderPremierCoverList = function () {
        return (React.createElement(React.Fragment, null,
            this.renderSingleTierItem(React.createElement(React.Fragment, null, "Fire, lightning, escape of water or oil")),
            this.renderSingleTierItem(React.createElement(React.Fragment, null, "Theft, storm, flood, impact, vandalism")),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Buildings Cover, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(1000000))), "Buildings Cover", modals.renderBuildingCoverModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Contents Cover, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(150000))), "Contents Cover", modals.renderContentsCoverModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null, "Buildings Accidental Damage"), "Buildings Accidental Damage", modals.renderBuildingsAccidentalDamageModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null, "Contents Accidental Damage"), "Contents Accidental Damage", modals.renderContentsAccidentalDamageModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null, "Home Legal Expenses"), "Home Legal Expenses", modals.renderLegalExpensesModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null, "Home Emergency"), "Home Emergency", modals.renderHomeEmergencyModal()),
            React.createElement(FalconAccordion_1.FalconAccordion, { togglePositionTop: false, toggleHidden: React.createElement("div", { className: "toggle text-left pl-1" },
                    React.createElement("i", { className: "fas fa-plus glyph-margin" }),
                    " Show more"), toggleShown: React.createElement("div", { className: "toggle text-left pl-1" },
                    React.createElement("i", { className: "fas fa-minus glyph-margin" }),
                    " Show less") }, this.renderPremierAdditionalCovers())));
    };
    AnnualHomeTierWidget.prototype.renderPremierAdditionalCovers = function () {
        return (React.createElement(React.Fragment, null,
            this.renderSingleTierItem(React.createElement(React.Fragment, null, "Accidental damage to cables, underground pipes and drains"), "Accidental damage to cables, underground pipes and drains", modals.renderCablePipeAccidentalDamageModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Alternative Accommodation, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(125000))), "Alternative Accommodation", modals.renderAlternativeAccommodationModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Money in the home, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(1000))), "Money in the home", modals.renderMoneyModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Credit cards, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(1000))), "Credit cards", modals.renderCreditCardsModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Loss of keys, up ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(1000))), "Loss of keys", modals.renderLossOfKeysModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Fatal injury, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(5000))), "Fatal injury", modals.renderFatalInjuryModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Title deeds, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(2500))), "Title deeds", modals.renderTitleDeedsModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Liability, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(2000000))), "Liability", modals.renderLiabilityModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Business equipment, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(10000))), "Business equipment", modals.renderBusinessEquipmentModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null, "Accidental damage to entertainment items"), "Accidental damage to entertainment items", modals.renderEntertainmentItemModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null, "Accidental damage to glass & baths & basins"), "Accidental damage to glass & baths & basins", modals.renderGlassAndSanitaryModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Contents away from the home, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(10000))), "Contents away from the home", modals.renderContentsAwayModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Contents in outbuildings, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(5000))), "Contents in outbuildings", modals.renderContentsInOutbuildingsModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Matching sets and suites, ",
                React.createElement("span", { className: "font-weight-bold" }, "50% "),
                " contribution"), "Matching sets and suites", modals.renderMatchingSetAndSuitesModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Contents in the garden, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(1000))), "Contents in the garden", modals.renderGardenContentsModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Freezer contents, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(1000))), "Freezer contents", modals.renderFreezerContentsModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                React.createElement("span", { className: "font-weight-bold" }, "Unlimited "),
                " downloaded information"), "Downloaded information", modals.renderDonwloadedInformationModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Student contents away from the home, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(10000))), "Student contents away from the home", modals.renderStudentContentsModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Visitor belongings, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(2500))), "Visitor belongings", modals.renderVisitorEffectsModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Contents in a nursing home, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(10000))), "Contents in a nursing home", modals.renderNursingHomeModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Plants in the garden, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(2500))), "Plants in the garden", modals.renderPlantsModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null, "Bicycles in the home"), "Bicycles in the home", modals.renderBicyclesModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Professional removal, up to ",
                React.createElement("span", { className: "font-weight-bold" }, "14 days")), "Professional removal", modals.renderProfessionalRemovalModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Valuables in the home, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(30000))), "Valuables in the home", modals.renderValuablesModal()),
            this.renderSingleTierItem(React.createElement(React.Fragment, null,
                "Valuable single article limit, up to ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(2000))), "Valuable single article limit", modals.renderValuableSingleArticleModal())));
    };
    AnnualHomeTierWidget.prototype.renderTierCheckboxes = function () {
        var _this = this;
        var tiers = new Map();
        if (this.renderBronzeTier) {
            tiers.set(services_1.BRONZE_TIER, "Bronze");
        }
        tiers.set(services_1.SILVER_TIER, "Silver");
        tiers.set(services_1.GOLD_TIER, "Gold");
        var rows = [];
        var shadowOverlay = [];
        tiers.forEach(function (tierName, code) {
            var isChecked = _this.isChecked(code);
            var backgroundColorClass = isChecked ? "background-color-primary " : "background-color-grey ";
            var wrapperClass = isChecked ? "col tier-input input-selected cursor-pointer" : "col tier-input cursor-pointer";
            var input = (React.createElement("div", { className: wrapperClass, onClick: function (event) { return _this.handleChange(code); } },
                React.createElement("div", { className: backgroundColorClass },
                    React.createElement("div", { key: code + "div", className: "pt-3 pb-4 padding-0" },
                        React.createElement("div", { className: "custom-radiobutton-container" },
                            React.createElement("input", { className: "custom-radiobutton", type: "radio", name: _this.props.question.name, key: code + "input", value: code, id: _this.props.question.name + code, checked: isChecked, onChange: function (e) { return _this.handleChange(code); } })),
                        React.createElement("div", { className: "tier-name" }, tierName),
                        _this.renderPremium(code)))));
            var overlay = (React.createElement("div", { className: isChecked ? "tier-selected col" : "col" }));
            shadowOverlay.push(overlay);
            rows.push(input);
        });
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row tier-checkboxes position-relative" },
                React.createElement("div", { className: "col-4" }),
                rows)));
    };
    AnnualHomeTierWidget.prototype.renderPremium = function (tier) {
        var showLyPremium = this.getSetting("showLastYearPrice", false);
        var factors = this.props.interaction.factors;
        var premiumType = factors.premiumType;
        var annualPremium;
        var monthlyPremium;
        var lyAnnualPremium;
        var lyMonthlyPremium;
        if (tier === services_1.BRONZE_TIER) {
            annualPremium = factors.bronzePremiums.totalAnnualPremium;
            monthlyPremium = factors.bronzePremiums.totalMonthlyPremium;
        }
        else if (tier === services_1.SILVER_TIER) {
            annualPremium = factors.silverPremiums.totalAnnualPremium;
            monthlyPremium = factors.silverPremiums.totalMonthlyPremium;
        }
        else {
            annualPremium = factors.goldPremiums.totalAnnualPremium;
            monthlyPremium = factors.goldPremiums.totalMonthlyPremium;
        }
        if (showLyPremium) {
            var renewalDetails = this.props.interaction.renewalDetails;
            var lyPremiums = renewalDetails.tieredLyPremiums.filter(function (p) { return p.tier === tier; })[0];
            lyAnnualPremium = lyPremiums.annualPremium;
            lyMonthlyPremium = lyPremiums.monthlyPremium;
        }
        return this.renderPremiumForTier(premiumType, annualPremium, monthlyPremium, lyAnnualPremium, lyMonthlyPremium);
    };
    AnnualHomeTierWidget.prototype.renderPremiumForTier = function (premiumType, annualPremium, monthlyPremium, lyAnnualPremium, lyMonthlyPremium) {
        if (premiumType === "annual") {
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "tier-premium-display" },
                    (0, commonFunctions_1.getAmountWithDecimalDigits)(annualPremium),
                    "/ year*"),
                lyAnnualPremium &&
                    React.createElement("span", { className: "tier-premium-display" },
                        "Last year's price: ",
                        (0, commonFunctions_1.getAmountWithDecimalDigits)(annualPremium),
                        "/ year*")));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "tier-premium-display" },
                    (0, commonFunctions_1.getAmountWithDecimalDigits)(monthlyPremium),
                    "/ month*"),
                lyAnnualPremium &&
                    React.createElement("span", { className: "tier-premium-display" },
                        "Last year's price: ",
                        (0, commonFunctions_1.getAmountWithDecimalDigits)(lyMonthlyPremium),
                        "/ month*")));
        }
    };
    AnnualHomeTierWidget.prototype.renderIncludedCoverRow = function (title, infoModalContent) {
        var isPlusTier = this.props.interaction.eligibleTier === services_1.SILVER_TIER;
        var numberOfRows = isPlusTier ? 2 : 3;
        var elementsToAdd = [];
        for (var i = 0; i < numberOfRows; i++) {
            var element = (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "col" },
                    React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-green-tick.svg"), alt: "tick icon", className: "wolf-green-tick" }))));
            elementsToAdd.push(element);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                this.renderTableEntryTitle(title, infoModalContent),
                elementsToAdd)));
    };
    AnnualHomeTierWidget.prototype.renderCoverLimit = function (title, bronzeAmount, silverAmount, goldAmount, infoModalContent) {
        var bronzeElement = (React.createElement(React.Fragment, null, bronzeAmount ?
            React.createElement("div", { className: "col d-flex" },
                React.createElement("p", null, "up to"),
                React.createElement("p", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(bronzeAmount))) :
            React.createElement("div", { className: "col" },
                React.createElement("img", { className: "multi-row cross-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/Flow-red-cross.svg"), alt: "tick icon" }))));
        var silverElement = (React.createElement(React.Fragment, null, silverAmount ?
            React.createElement("div", { className: "col d-flex" },
                React.createElement("p", null, "up to"),
                React.createElement("p", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(silverAmount))) :
            React.createElement("div", { className: "col" },
                React.createElement("img", { className: "multi-row cross-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/Flow-red-cross.svg"), alt: "tick icon" }))));
        var goldElement = (React.createElement(React.Fragment, null, goldAmount ?
            React.createElement("div", { className: "col d-flex" },
                React.createElement("p", null, "up to"),
                React.createElement("p", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(goldAmount))) :
            React.createElement("div", { className: "col" },
                React.createElement("p", { className: "font-weight-bold unlimited-cover" }, "Unlimited"))));
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                this.renderTableEntryTitle(title, infoModalContent),
                this.renderTableColumn(bronzeElement, silverElement, goldElement))));
    };
    AnnualHomeTierWidget.prototype.renderOptionalExtras = function (title, addonField, addonValue, stateField, infoModalContent) {
        var _this = this;
        var inclusionWording = addonValue ? "Added" : "Optional";
        var buttonLabel = addonValue ? "Remove" : "Add"; // \u00A0 -- non-breakable space
        var addonElement = (React.createElement("div", { className: "col" },
            React.createElement("p", { className: "margin-bottom-0" }, inclusionWording),
            React.createElement("button", { type: "button", className: "mt-0 mb-0 pb-1 blue-link font-weight-bold", onClick: function (e) { return _this.handleAddonChangeEvent(e, addonField, addonValue, stateField); } }, buttonLabel)));
        var premierElement = (React.createElement("div", { className: "col" },
            React.createElement("p", { className: "font-weight-bold unlimited-cover" }, "Included as standard")));
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                this.renderTableEntryTitle(title, infoModalContent),
                this.renderTableColumn(addonElement, addonElement, premierElement))));
    };
    AnnualHomeTierWidget.prototype.renderOptionalCovers = function (title, bronzeIncluded, silverIncluded, goldIncluded, infoModalContent) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                this.renderTableEntryTitle(title, infoModalContent),
                this.renderTableColumn(this.renderOptionalWording(bronzeIncluded), this.renderOptionalWording(silverIncluded), this.renderOptionalWording(goldIncluded)))));
    };
    AnnualHomeTierWidget.prototype.renderMatchingSets = function () {
        var element = (React.createElement("div", { className: "col" },
            React.createElement("p", { className: "font-weight-bold" }, "50%"),
            React.createElement("p", null, "contribution")));
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                this.renderTableEntryTitle("Matching sets and suites", modals.renderMatchingSetAndSuitesModal()),
                this.renderTableColumn(element, element, element))));
    };
    AnnualHomeTierWidget.prototype.renderProfessionalRemoval = function () {
        var notIncludedElement = (React.createElement("div", { className: "col" },
            React.createElement("img", { className: "multi-row cross-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/Flow-red-cross.svg"), alt: "tick icon" })));
        var includedElement = (React.createElement("div", { className: "col d-flex" },
            React.createElement("p", null, "up to"),
            React.createElement("p", { className: "font-weight-bold" }, "14 days")));
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                this.renderTableEntryTitle("Professional removal", modals.renderProfessionalRemovalModal()),
                this.renderTableColumn(notIncludedElement, includedElement, includedElement))));
    };
    AnnualHomeTierWidget.prototype.renderOptionalWording = function (coverIncluded) {
        if (coverIncluded) {
            return (React.createElement("div", { className: "col" },
                React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-green-tick.svg"), alt: "tick icon", className: "wolf-green-tick" })));
        }
        else {
            return (React.createElement("div", { className: "col" },
                React.createElement("p", { className: "unlimited-cover margin-bottom-0" }, "optional")));
        }
    };
    AnnualHomeTierWidget.prototype.renderSelectButtons = function (coverTier, bronzeHidden) {
        return (React.createElement("div", { className: "row tier-select-buttons ".concat(bronzeHidden) },
            React.createElement("div", { className: "col-4" }),
            this.renderTableColumn(this.renderSelectButton(coverTier, services_1.BRONZE_TIER), this.renderSelectButton(coverTier, services_1.SILVER_TIER), this.renderSelectButton(coverTier, services_1.GOLD_TIER))));
    };
    AnnualHomeTierWidget.prototype.renderSelectButton = function (coverTier, cover) {
        var _this = this;
        var wrapperCssClass;
        var cssClass;
        var label;
        if (coverTier === cover) {
            wrapperCssClass = "col pr-1 pl-1 selected";
            cssClass = "btn btn-select selected icon-tick-white-before annual-home-cover-button";
            label = "Your chosen cover";
        }
        else {
            wrapperCssClass = "col pr-1 pl-1";
            cssClass = "btn btn-select";
            label = "Select";
        }
        return (React.createElement("div", { className: wrapperCssClass },
            React.createElement("button", { type: "button", className: cssClass, id: "select" + cover, value: cover, onClick: function (e) { return _this.handleChange(cover); } }, label)));
    };
    AnnualHomeTierWidget.prototype.renderTableColumn = function (bronzeElement, silverElement, goldElement) {
        var columns = [];
        if (this.renderBronzeTier) {
            columns.push(bronzeElement);
        }
        columns.push(silverElement);
        columns.push(goldElement);
        return columns;
    };
    AnnualHomeTierWidget.prototype.renderSingleTierItem = function (wording, modalTitle, infoModalContent) {
        return (React.createElement("div", { className: "mb-3 single-tier-item" },
            React.createElement("div", { className: "mb-3 d-flex" },
                React.createElement("img", { className: "mt-0 wolf-green-tick", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-green-tick.svg"), alt: "tick icon" }),
                React.createElement("span", { className: "mb-0" }, wording),
                infoModalContent && modalTitle &&
                    React.createElement(InfoModal_1.InfoModal, { className: "fixed-addon-info-icon", title: modalTitle }, infoModalContent))));
    };
    AnnualHomeTierWidget.prototype.renderTableEntryTitle = function (title, infoModalContent) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "col-4" },
                React.createElement("p", { className: "margin-bottom-0 d-flex" },
                    title,
                    infoModalContent &&
                        React.createElement(InfoModal_1.InfoModal, { className: "fixed-addon-info-icon", title: title }, infoModalContent)))));
    };
    AnnualHomeTierWidget.prototype.renderPolicyDocumentSection = function () {
        var renewalContent = this.getSetting("linkToRenewal", false);
        var content = renewalContent ? (React.createElement("p", null,
            "Open the ",
            React.createElement(react_router_dom_1.Link, { to: "/resources/documents/LV_Allianz_Annual_Home/v2/LV_Allianz_Home_DOI.pdf", target: "_blank", download: true }, "policy document"),
            " or go to \"",
            React.createElement(react_router_dom_1.Link, { to: "#", onClick: this.navigateToRenewal }, "Your renewal, make changes"),
            "\" to see full cover details")) :
            (React.createElement("p", null,
                "Open the ",
                React.createElement(react_router_dom_1.Link, { to: "/resources/documents/LV_Allianz_Annual_Home/v2/LV_Allianz_Home_DOI.pdf", target: "_blank", download: true }, "policy document"),
                " to see full cover details"));
        return (React.createElement("div", { className: "margin-top-80 mb-5" },
            content,
            React.createElement("p", null, "* All figures include Insurance Premium Tax")));
    };
    AnnualHomeTierWidget.prototype.renderSuggestionModal = function () {
        var modalTitle = "Because of the changes you've made...";
        return (React.createElement(SuggestionModal_1.SuggestionModal, { title: modalTitle, isSuggestionModalOpen: this.state.isSuggestionModalOpen, toggleSuggestionModal: this.toggleSuggestionModal }, modals.renderFlowPremierSuggestionModal()));
    };
    AnnualHomeTierWidget.prototype.isChecked = function (id) {
        return (id === "".concat(this.bindFromField(this.props.question.interactionField)));
    };
    AnnualHomeTierWidget.prototype.handleChange = function (selectedTier) {
        this.recordPreviousTierLevel();
        journey_services_1.ObjectManipulator.setField(this.props.question.interactionField, this.props.interaction, selectedTier);
        var prevTierLevel = this.props.interaction.uistate.annualHomeAddonsState.previousTierLevel;
        if (prevTierLevel !== services_1.GOLD_TIER) {
            this.recordPreviousAddons();
        }
        this.resetAddons(selectedTier === services_1.GOLD_TIER);
        if (selectedTier === services_1.GOLD_TIER) {
            this.updatePossessions(true);
        }
        else {
            this.updatePossessions(false);
        }
        this.executeEvent("change");
    };
    AnnualHomeTierWidget.prototype.resetAddons = function (isPremier) {
        var annualHomeAddonsState = this.props.interaction.uistate.annualHomeAddonsState;
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.buildingAccidentalDamage", this.props.interaction, isPremier ? true : annualHomeAddonsState.buildingAccidentalDamage);
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.contentsAccidentalDamage", this.props.interaction, isPremier ? true : annualHomeAddonsState.contentsAccidentalDamage);
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.homeLegalExpenses", this.props.interaction, isPremier ? true : annualHomeAddonsState.homeLegalExpenses);
        journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.homeEmergency", this.props.interaction, isPremier ? true : annualHomeAddonsState.homeEmergency);
    };
    AnnualHomeTierWidget.prototype.recordPreviousAddons = function () {
        var annualHomeFixedAddons = this.props.interaction.annualHomeFixedAddons;
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.buildingAccidentalDamage", this.props.interaction, annualHomeFixedAddons.buildingAccidentalDamage);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.contentsAccidentalDamage", this.props.interaction, annualHomeFixedAddons.contentsAccidentalDamage);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.homeLegalExpenses", this.props.interaction, annualHomeFixedAddons.homeLegalExpenses);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.homeEmergency", this.props.interaction, annualHomeFixedAddons.homeEmergency);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.personalPossessionCoverLimit", this.props.interaction, this.props.interaction.annualHomeExtraCovers.personalPossessionCoverLimit);
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.personalPossessionsCover", this.props.interaction, this.props.interaction.annualHomeExtraCovers.personalPossessionsCover);
    };
    AnnualHomeTierWidget.prototype.recordPreviousTierLevel = function () {
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.previousTierLevel", this.props.interaction, this.props.interaction.coverTier);
    };
    AnnualHomeTierWidget.prototype.updatePossessions = function (value) {
        journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionsCover", this.props.interaction, value ? value : this.props.interaction.uistate.annualHomeAddonsState.personalPossessionsCover);
        var personalPossessionCoverLimit = this.props.interaction.annualHomeExtraCovers.personalPossessionCoverLimit;
        var premierPersonalPossessionCoverLimit = personalPossessionCoverLimit >= 2000 ? personalPossessionCoverLimit : 2000;
        journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionCoverLimit", this.props.interaction, value ? premierPersonalPossessionCoverLimit : this.props.interaction.uistate.annualHomeAddonsState.personalPossessionCoverLimit);
    };
    AnnualHomeTierWidget.prototype.switchPremiumType = function () {
        var newPremiumType = this.props.interaction.factors.premiumType === "annual" ? "monthly" : "annual";
        this.props.onStateChange("factors.premiumType", newPremiumType);
        this.executeEvent("change");
    };
    AnnualHomeTierWidget.prototype.handleAddonChangeEvent = function (event, addonField, addonValue, stateField) {
        event.preventDefault();
        this.props.onStateChange(addonField, !addonValue);
        this.props.onStateChange(stateField, !addonValue);
        if (!addonValue) {
            this.handleTierPopup(addonField);
        }
        // terrible hack, not sure on any other options for now though as onChange event already does a different thing
        this.executeEvent("blur");
    };
    AnnualHomeTierWidget.prototype.handleTierPopup = function (addonField) {
        if (addonField === "annualHomeFixedAddons.buildingAccidentalDamage" && !this.state.buildingsAdPopupTriggered) {
            this.setState({
                buildingsAdPopupTriggered: true
            });
            this.toggleSuggestionModal();
        }
        else if (addonField === "annualHomeFixedAddons.contentsAccidentalDamage" && !this.state.contentsAdPopupTriggered) {
            this.setState({
                contentsAdPopupTriggered: true
            });
            this.toggleSuggestionModal();
        }
        else if (addonField === "annualHomeFixedAddons.homeLegalExpenses" && !this.state.legalExpensesPopupTriggered) {
            this.setState({
                legalExpensesPopupTriggered: true
            });
            this.toggleSuggestionModal();
        }
        else if (addonField === "annualHomeFixedAddons.homeEmergency" && !this.state.homeEmergencyPopupTriggered) {
            this.setState({
                homeEmergencyPopupTriggered: true
            });
            this.toggleSuggestionModal();
        }
    };
    AnnualHomeTierWidget.prototype.toggleSuggestionModal = function () {
        this.setState({
            isSuggestionModalOpen: !this.state.isSuggestionModalOpen
        });
    };
    AnnualHomeTierWidget.prototype.navigateToRenewal = function () {
        this.props.engine.navigate("viewAndEditRenewalProposalPage", false);
    };
    AnnualHomeTierWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "showPremiumTypeSwitch", type: journey_model_1.TypeDescriptions.Boolean },
            { name: "showLastYearPrice", type: journey_model_1.TypeDescriptions.Boolean },
            { name: "linkToRenewal", type: journey_model_1.TypeDescriptions.Boolean }
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualHomeTierWidget);
    return AnnualHomeTierWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualHomeTierWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomeTierWidget.js
// module id = 3693
// module chunks = 0